import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { OrderServices } from "../services/OrderServices";

const PayPalCancelPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCancel = async () => {
      const orderId = searchParams.get("order_id");

      if (orderId) {
        try {
          await OrderServices.cancelPayPalPayment(parseInt(orderId, 10));
        } catch (err) {
          console.error("Cancel payment error:", err);
        }
      }
    };

    handleCancel();
  }, [searchParams]);

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "2rem"
    }}>
      <div style={{
        maxWidth: "500px",
        textAlign: "center",
        background: "#fffbeb",
        border: "1px solid #fde68a",
        borderRadius: "12px",
        padding: "2rem"
      }}>
        <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>⚠️</div>
        <h3 style={{ color: "#92400e", marginBottom: "1rem" }}>Payment Cancelled</h3>
        <p style={{ color: "#78350f", marginBottom: "1.5rem" }}>
          You cancelled the PayPal payment. Your order has been created but not paid.
          You can retry payment from your order history or return to cart.
        </p>
        <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap" }}>
          <button
            onClick={() => navigate("/cart")}
            className="btn btn-outline-main py-14 px-24 rounded-8"
          >
            Return to Cart
          </button>
          <button
            onClick={() => navigate("/account/orders")}
            className="btn btn-main py-14 px-24 rounded-8"
          >
            View Orders
          </button>
        </div>
      </div>
    </div>
  );
};

export default PayPalCancelPage;